export const appVersion = {
  version: 'v26.06.25',
  deploy: '-dev.15',
};
